const home = {
  title: 'Valida tu documento',
  validate_with_document: {
    title: 'Validar documento a través de un PDF',
    description: 'Tengo un documento firmado por Clicksign.',
    button: 'Validar con documento',
  },
  generate_password: {
    title: 'Generar contraseña para validación a través de un PDF',
    description: 'Necesito generar una contraseña para que sea validado por terceros.',
    button: 'Generar contraseña',
  },
  validate_with_password: {
    title: 'Validar documento a través de Contraseña',
    description: 'Tengo la contraseña de acceso al documento electrónico.',
    button: 'Validar con contraseña',
  },
  renew_certificate: {
    title: 'Renovar el certificado',
    subtitle: 'Utiliza esta opción para renovar los certificados vencidos.',
    validate_with_document: {
      title: 'Renovar el certificado del documento',
      description: 'Tengo el documento firmado y quiero actualizar el certificado Clicksign.',
      button: 'Validar con documento',
    },
  },
  document_p7s: {
    title: 'Descargar el documento firmado en formato p7s',
    subtitle: 'Usa esta opción para descargar los documentos ya firmados.',
    card: {
      title: 'Descargar documento en p7s',
      description: 'Tengo el documento firmado y quiero descargarlo en formato p7s.',
      button: 'Descargar documento',
    },
  },
};

export default home;
